
const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = window.sessionStorage.getItem("jwtToken");

export const addExploreData = async (exploreData) => {
  try {
    const response = await fetch(`${BASE_URL}/addExploreData`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': 'http://68.183.95.58:8080',
        'Access-Control-Allow-Credentials': 'true',
         Authorization: `Bearer ${token}`
      },
    
      body: JSON.stringify(exploreData),
    });
    if (!response.ok) {
      throw new Error('Failed to add explore data');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error adding explore data:', error);
    throw error;
  }
};
